import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import {useEffect} from "react"
import DvsaFeeCard from "../../components/Fees/dvsaFeeCard"
import {RootState} from "../../rootReducer"
import {LoadingPanel} from "../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../store"
import {fetchDvsaFeeById, fetchDvsaFees} from "./dvsaFeesSlice"

const DvsaFees = () => {
    const dispatch = useAppDispatch()

    const loading = useAppSelector((state: RootState) => state.containers.dvsaFees.showLoader)
    const dvsaModalOpen = useAppSelector((state: RootState) => state.containers.dvsaFees.dvsaModalOpen)
    const selectedDvsaId = useAppSelector((state: RootState) => state.containers.dvsaFees.selectedDvsaID)

    useEffect(() => {
        dispatch(fetchDvsaFees())
    }, [dispatch])

    useEffect(() => {
        if (dvsaModalOpen) {
            dispatch(fetchDvsaFeeById(selectedDvsaId))
        }
    }, [dispatch, dvsaModalOpen, selectedDvsaId])

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Settings </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>DVSA Fee</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            {loading && <LoadingPanel />}
            <DvsaFeeCard />
        </>
    )
}

export default DvsaFees
